define('views/AppView',['jquery',
        'underscore',
        'backbone',
        'app',
        'router',
        'site_vars',
        'LogExecutionTime',
        'prototypes/PageFactory',
        'ErrorModel',
        'ApiRequest',
        'views/blocks/HeaderView',
        'views/blocks/FooterView',
        'views/blocks/SideNavView',
        'views/blocks/LoaderView',
        'views/blocks/CartMobileView',
        'views/blocks/AppInstallView',
        'views/blocks/FakeBannerAppView',
        'AlertNoticeView',
        'ConfirmNoticeView',
        'PromptNoticeView',
        'BottomNoticeView',
        'BanNoticeView',
        'views/blocks/CustomerServiceBoxView',
        'views/blocks/SubscribePostcodeView',
        'views/blocks/checkout/ConfirmationCodePromptDialogView',
        'template!blocks/submit-form',
        'template!blocks/ui/btn-close',
        'bootstrap/collapse'],
    function ($,
              _,
              backbone,
              app,
              router,
              site_vars,
              LogExecutionTime,
              PageFactory,
              ErrorModel,
              ApiRequest,
              HeaderView,
              FooterView,
              SideNavView,
              LoaderView,
              CartMobileView,
              AppInstallView,
              FakeBannerAppView,
              AlertNoticeView,
              ConfirmNoticeView,
              PromptNoticeView,
              BottomNoticeView,
              BanNoticeView,
              CustomerServiceBoxView,
              SubscribePostcodeView,
              ConfirmationCodePromptDialogView,
              submitFormTemplate,
              btnCloseTemplate
    ) {

        var appView,
            firstPageView = true,
            currentPageViews = [], // représente les pages en cours, en modal ou main

            mainScrollTop = 0, // scrollTop du main
            mainEl,

            footerView,
            cartMobileView,

            modals = [],
            modalsWrapperEl,

            _pageStarting = false,

            APP_HEADER_PREFIX = 'X-app-';

        function DecodeHeader(key,xhr){return decodeURIComponent(xhr.getResponseHeader(APP_HEADER_PREFIX+key))};


        return backbone.View.extend({
            'el':'body',
            events:{
            },
            initialize:function(){

                appView = this;

                // if (site_vars.env == "dev") {
                    window.onerror = function (errMessage,file,col,line,err) {

                        new ErrorModel({error:errMessage,stack:err});

                        // affichage du message d'erreur inconnue
                        if(site_vars.display_js_error_alert) {
                            //
                            if(($('.js-error').length==0) && (errMessage!='Script error.')){
                                var button = $('<button class="js-error"><i class="icon-alert"></i></button>');
                                appView.$el.append(button);
                                var message, alertTitle = 'Attention';
                                try{
                                    // gestion de la traduction
                                    message = app.t('Une erreur inconnue est survenue.','Error');
                                    alertTitle = app.t(alertTitle,'UI');
                                }catch(err){
                                    // fallback en cas d'erreur de traduction, en anlais (par défaut)
                                    message = 'Unknown error';
                                }
                                app.tc_error(button.get(0),message,errMessage);
                                button.click(function(){
                                    app.alert({
                                        title: alertTitle,
                                        subtitle: message+'<code>'+errMessage+'</code>'
                                    },function(){
                                        button.remove();
                                    });
                                });
                            }
                        }

                }

                // app singleton

                mainEl = appView.$('main');
                modalsWrapperEl = appView.$('.modals-wrapper');

                app.$body.toggleClass('webapps',site_vars.webapps);

                // waiting for hooks loading
                appView.listenTo(app,'hooksStarted',appView.hooksStarted);

                //
                // Setup router events
                //
                router.on('ajaxloaded',appView.ajaxLoaded,appView);
                router.on('templateCategory',appView.templateCategory,appView);
                router.on('displayMicrotemplating',appView.displayMicrotemplating,appView);
                //
                app.on('displayModal',appView.displayModal,appView);
                //
                app.on('alertNotice',appView.alertNotice,appView);
                app.on('promptNotice',appView.promptNotice,appView);
                app.on('confirmNotice',appView.confirmNotice,appView);
                app.on('bottomNotice',appView.bottomNotice,appView);
                app.on('banNotice',appView.banNotice,appView);
                //
                app.on('ws__notice',appView.wsNotice,appView);

                app.on('networkError',appView.onNetworkError,appView);

                app.on('submitForm',appView.submitForm,appView);

                app.on('openSubscribePostcodeView',appView.openSubscribePostcodeView,appView);
                app.on('openConfirmationCodePromptDialogView',appView.openConfirmationCodePromptDialogView,appView);
                app.on('toggleTopBanner',appView.onToogleTopBanner,appView);

                appView.listenTo(app,'change:deviceType',appView.reload);

                app.$window.resize($.proxy(appView.onResize,appView));
                app.$window.scroll($.proxy(appView.onScroll,appView));

                appView.onResize();
            },
            hooksStarted:function(){

                LogExecutionTime('AppView hooksStarted',7);

                // stop listening hooksStarted
                app.off('hooksStarted');

                //
                // Setup Header & Footer
                //
                new HeaderView();
                footerView = new FooterView();
                new SideNavView();
                new LoaderView();
                if(app.getCustomer().isLogged() == true) {
                    var ordering = app.getCustomer().getOrdering();
                    if (ordering.size() > 0) {
                        new CustomerServiceBoxView();
                    }
                }

                if(app.isMobile()){
                    cartMobileView = new CartMobileView();
                }
                LogExecutionTime('HeaderView, FooterView, initialized');

                //
                //
                //

                //
                // Setup Page View
                //
                var pageEl = appView.$('main > .page'),
                    pageName = pageEl.data('pagename');
                appView.startPage(pageName,pageEl.get(0),router.currentRoute());
                LogExecutionTime('PageView initialized');
                $('html').addClass('initialized');
                app.trigger('hideLoader');

                if(AppInstallView.requireOpenning()){
                    appView.displayModal(new AppInstallView());
                }
                if(FakeBannerAppView.requireOpenning()){
                    var fakeBannerView = new FakeBannerAppView();
                    appView.$el.append(fakeBannerView.el);
                }

            },
            startPage:function(name,el,url,options){
                //
                // Démarre une page
                //
                _pageStarting = true;

                var newPageView,
                    lastMainPageView = _(currentPageViews).findWhere({displayAsModal:false,pageName:name,url:url}),
                    displayAsModal;
                //
                if(_.isUndefined(options)){
                    options = {};
                }
                options.el = el;
                //

                if(lastMainPageView){
                    //
                    // cas fermeture de popin
                    // avec vue dans main pré-existant
                    newPageView = lastMainPageView;
                }else{
                    //
                    // cas normal de fabrication d'une nouvelle vue
                    //
                    try {
                        var pageViewClass = new PageFactory(name); // fabrique la vue de la page à partir de son nom
                        newPageView = new pageViewClass(options);  // instancie la vue
                    }catch(error){
                        app.alert({
                            title:app.t('Erreur','UI'),
                            subtitle:app.t('la page n’a pu être affichée en raison d’une erreur','Error')
                        });
                        app.error(error.toString(),options);
                        _pageStarting = false;
                        return;
                    }

                }
                //
                displayAsModal = newPageView.displayAsModal;
                //
                el = newPageView.el;

                // supprime toutes les modals lors d'un démarrage de page
                if(lastMainPageView || (!firstPageView)){
                    appView.removeAllModals(displayAsModal);
                }

                // cache le footer sur certaines pages (Listing …)

                if(!displayAsModal){
                    appView.removeAllPages(!_.isUndefined(lastMainPageView));
                    appView.displayFooter(!newPageView.hideFooter);
                    appView.displayMobileCart(!newPageView.hideMobileCart);
                }

                newPageView.url = url;

                if (newPageView != currentPageViews[0]) {
                    // ajoute la nouvelle vue à la liste des pages ouvertes
                    currentPageViews.push(newPageView);
                }

                //
                if(displayAsModal){
                    // si l’élement doit être affiché comme une page Modal
                    appView.displayModal(newPageView);
                    //
                }else{
                    // on affiche le header, si on est pas sur une popin
                    app.trigger('showHeader');

                    // si l’élement doit afficher classiquement dans <main>
                    if(_.isNull(el.parentElement)) {
                        // si l'element n'a pas de parent
                        // injecte la page dans <main>
                        mainEl.prepend(el);
                    }
                }
                newPageView.startPageTagCommander(options);

                requestAnimationFrame(function(){
                    newPageView.initialRender();
                    app.updateDocumentDimensions();
                    app.trigger('pageChange', name, displayAsModal);
                });

                // Meta Title
                newPageView.initialMetaTitle();

                firstPageView = false;
                _pageStarting = false;

            },

            removeAllPages:function(exceptFirst){
                var popedPageView = true;
                while(popedPageView){
                    if(currentPageViews.length>(exceptFirst?1:0)){
                        popedPageView = currentPageViews.pop();
                        if(popedPageView){
                            popedPageView.remove();
                        }
                    }else{
                        popedPageView = false;
                    }
                };
            },

            getCurrentMainPageView:function(){
                return _(currentPageViews).findWhere({displayAsModal:false});
            },

            displayMicrotemplating:function(url,pageName,options){
                var currentPageView = _(currentPageViews).last();
                if (currentPageView) {
                    if(currentPageView.pageName != pageName){
                        // startup a new pageView
                        options.microtemplateStart = true;
                        appView.startPage(pageName,undefined,url,options);
                    }else if(currentPageView){
                        // use the current pageView
                        currentPageView.url = url;
                        currentPageView.microtemplate(options);
                        currentPageView.startPageTagCommander(options);
                        app.updateDocumentDimensions();
                    }else{
                    }
                } else {
                }

            },

            displayModal:function(modalView){
                if(!modalsWrapperEl.is('.active')) {
                    //
                    // si on est en wrapper <main>
                    // on passe en wrapper modals
                    //
                    mainScrollTop = app.$window.scrollTop();
                    app.set('scrollLocked',true);
                    mainEl.addClass('lock-scroll');
                    mainEl.scrollTop(mainScrollTop);
                    modalsWrapperEl.addClass('active');
                }else{
                    modalsWrapperEl.find('> .modal-wrapper:not(.lock-scroll)').each(function(index,modalWrapper){
                        var $modalWrapper = $(modalWrapper),
                            scrollTop = app.$window.scrollTop();
                        $modalWrapper.addClass('lock-scroll').data('scrollTop',scrollTop).scrollTop(scrollTop);
                    })
                }
                modalsWrapperEl.attr('data-overlay',modalView.overlay || 'opaque');
                modalsWrapperEl.append(modalView.el);
                var modalClassName = (_.isFunction(modalView.className) ? modalView.className() : modalView.className) || '';
                modalView.$el.wrap('<div class="modal-wrapper '+(modalClassName)+'" data-id='+modalView.cid+'></div>');
                modalView.wrapper = modalView.$el.parent();
                modals.push(modalView);
                app.$window.scrollTop(0);
                modalView.on('close',appView.closeModal,appView);
            },

            closeModal:function(modalView){

                if(!modalView){return;}

                var modalWrapper = modalView.wrapper;
                modals.splice(modals.indexOf(modalView),1);
                modalWrapper.remove();
                modalView.remove();
                modalsWrapperEl.find('> .lock-scroll:last').each(function(){
                    $(this).removeClass('lock-scroll');
                    app.set('scrollLocked',false);
                    app.$window.scrollTop($(this).data('scrollTop'));
                });
                if(modals.length==0){
                    var lastMainPageView = appView.getCurrentMainPageView();
                    appView.removeAllModals();
                    if(lastMainPageView && lastMainPageView.url){
                        appView.removeAllPages(true);
                        if(!_pageStarting){
                            router.pushState(lastMainPageView.url);
                            lastMainPageView.reloadMeta();
                        }
                    }else if(modalView.pageName == 'ProductPage'){
                        // Les pages produits ramènent vers la page catégorie par défaut du produit
                        try{
                            app.go('category',{category_link_rewrite:modalView.product.getCategoryDefault().getLinkRewrite()});
                        }catch(err){
                            app.go('listing');
                            new Error({error:'Impossible de fermer la page produit',debug:{id_product:modalView.id_product},stack:err});
                        }
                        //
                    }else{
                        app.go('home');
                    }
                }else{
                    var topModalView = modals[modals.length-1];
                    modalsWrapperEl.attr('data-overlay',topModalView.overlay || 'opaque');
                }
            },

            displayFooter:function(display){
                footerView.toggle(display && !Modernizr.inapp);
            },

            displayMobileCart:function(display){
                if(cartMobileView){
                    cartMobileView.toggle(display);
                }
            },

            openNotice:function(NoticeConstructor,params,callback){
                var notice = new NoticeConstructor(params);
                notice.on('noticeClose', function(val,cb){
                    if(_.isFunction(callback)){
                        callback(val,cb);
                    }
                });
            },

            wsNotice:function(wsMessage){
                var dataMessage = wsMessage.data,
                    NoticeView;
                switch(dataMessage.ui){
                    case 'ban': NoticeView = BanNoticeView; break;
                    case 'confirm': NoticeView = ConfirmNoticeView; break;
                    case 'bottom': NoticeView = BottomNoticeView; break;
                    case 'alert': default : NoticeView = AlertNoticeView;
                }
                appView.openNotice(NoticeView,dataMessage.params);
            },

            alertNotice: function(params, callback){
                appView.openNotice(AlertNoticeView, params, callback);
            },

            confirmNotice: function(params, callback){
                appView.openNotice(ConfirmNoticeView,params, callback);
            },
            promptNotice: function(params, callback){
             appView.openNotice(PromptNoticeView,params, callback);
            },
            bottomNotice: function(params){
                new BottomNoticeView(params);
            },

            banNotice: function(params){
                new BanNoticeView(params);
            },

            onNetworkError:function(error){
                app.alert(
                    {
                        title:app.t('Problème de connection','Error'),
                        subtitle:app.t('Veuillez vérifier votre connection réseau.','Error')
                    },
                    function(){
                        // recharge la page en cas d'erreur réseau
                        window.location.reload();
                    }
                );
            },

            removeAllModals:function(preserveActive){
                // si on garde
                if(preserveActive!=true){
                    //
                    mainScrollTop = mainEl.scrollTop();
                    mainEl.removeClass('lock-scroll');
                    app.set('scrollLocked',false);
                    modalsWrapperEl.removeClass('active');
                    //
                    app.$window.scrollTop(mainScrollTop);
                }
                //
                _(modals).each(function(modalView){
                    appView.closeModal(modalView);
                });
                modals = [];
            },

            ajaxLoaded:function(data,xhr,url){
                //
                // Trigger after router ajax success
                //
                var controllerName = DecodeHeader('controllerName',xhr),
                    el = $('<div class="page '+controllerName+'">'+data+'</div>').get(0);
                //
                appView.startPage(controllerName,el,url);
                //
                //
                appView.updateMetaTags(DecodeHeader('metaTitle',xhr),DecodeHeader('metaDescription',xhr),DecodeHeader('metaKeywords',xhr))
            },
            updateMetaTags:function(title,description,keywords){
                //
                // update html meta tags
                //
                if(title){
                    $('title,meta[property="og:title"]').text(title);
                }
                if(description){
                    $('meta[name="description"],meta[property="og:description"]').text(description);
                }
            },
            templateCategory:function(category){
                var CategoryPageView = PageFactory('Category'),
                    pageView = new CategoryPageView({name:category});
                appView.startPage('Category',pageView.el);
            },

            onToogleTopBanner: function(visible){
                this.$el.toggleClass('offset--no-more',!visible);
                this.$el.toggleClass('offset-top-banner',!!visible);
            },
            openSubscribePostcodeView:function(addressAutocompleteModel,callback){
                appView.openNotice(SubscribePostcodeView,{addressAutocompleteModel:addressAutocompleteModel}, callback);
            },
            openConfirmationCodePromptDialogView:function(params,callback){
                var confirmationCodePromptDialogView = new ConfirmationCodePromptDialogView(params);
                confirmationCodePromptDialogView.once('close',function(view,value,requestNewCode){
                    callback(value,requestNewCode);
                });
            },
            onScroll:function(event){
                var scrollTop = app.$window.scrollTop();
                app.set('scrollTop', scrollTop);
                app.trigger('scroll',event,scrollTop);
            },
            onResize:function(){
                app.updateDocumentDimensions();
                app.set({deviceType: (Modernizr.mq('only all and (max-width: 991px)') ? 'mobile' : 'desktop')});
                app.trigger('resize');
            },
            reload: function(){
                if(app.previous("deviceType")){
                    location.reload();
                }
            },
            submitForm:function(options){
                var view = this,
                    form = $(submitFormTemplate(options));
                view.$el.append(form);
                form.submit();
            }
        });
    });
